import React, {Component} from 'react'
import {Typeahead} from 'react-bootstrap-typeahead-ali/dist/react-bootstrap-typeahead'
import {Media, Row, Col, Image} from 'react-bootstrap'
import {Actions} from 'jumpstate'
import HorseBox from '../Common/HorseBox/HorseBox'

import './Layout/HorseFinder.css'

const horseAvatar = `${window.location.protocol}//${window.location.host}/horse.jpg`

class HorseFinder extends Component {
  constructor (props) {
    super(props)
    this.state = {
      term: '',
      options: [],
      message: '',
      horse: {
        id: null,
        name: '',
        avatar: null,
        strain: null,
        genderType: 'female',
        sire: {key: null, name: 'پدر', strain: null},
        dam: {key: null, name: 'مادر', strain: null},
        key: '(نامشخص)',
        isOwner: false
      }
    }
    this.timeout = null
    this.seek = this.seek.bind(this)
    this.pickOption = this.pickOption.bind(this)
    this.changeKeyword = this.changeKeyword.bind(this)
  }

  seek (keyword) {
    Actions.autocompleteHorseWithBasicData(keyword).then((res) => {
      if (res.data.length === 0) {
        this.setState({options: [], message: 'موردی یافت نشد'})
      } else {
        this.setState({options: res.data, message: ''})
      }
    })
  }

  pickOption (picked) {
    if (picked.length === 0) { return undefined }
    Actions.horseInfo(picked[0].key).then((res) => {
      const pickedHorse = {...picked[0], ...res}
      this.setState({horse: pickedHorse})
      this.props.resultHandler(pickedHorse)
    })
  }

  changeKeyword (keyword) {
    this.setState({message: keyword, term: keyword})
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
    if (keyword.length > 0) {
      this.timeout = setTimeout(() => {
        Actions.autocompleteHorseWithBasicData(keyword).then((res) => {
          if (res.data.length === 0) {
            this.setState({options: [], message: 'موردی یافت نشد'})
          } else {
            this.setState({options: res.data, message: ''})
          }
        })
      }, 700)
    } else {
      this.setState({message: '', options: []})
    }
  }

  render () {
    const {options, message, horse} = this.state
    const {placeholder, errors} = this.props

    return (
      <Row className="horse-finder">
        <Col xs={12}>
          <Typeahead
            onChange={this.pickOption}
            onInputChange={this.changeKeyword}
            emptyLabel={message}
            placeholder={placeholder}
            className={`Name blink ${errors ? 'has-error' : ''} ${!horse.id ? 'large-input' : 'small-input'}`}
            labelKey="name"
            options={options}
            defaultText={horse.name}

            renderMenuItemChildren={(option) => {
              return [
                <Media key={option.id}>
                  <Media.Left>
                    <Image width={32} height={32} src={option.avatar ? option.avatar : horseAvatar} />
                  </Media.Left>
                  <Media.Body>
                    <Media.Heading>{option.name}</Media.Heading>
                    <p>{option.strain}</p>
                  </Media.Body>
                </Media>
              ]
            }}
          />
        </Col>
        <Col xs={12}>
          {horse.id && <HorseBox horse={horse} />}
        </Col>
      </Row>
    )
  }
}

HorseFinder.propTypes = {
  resultHandler: React.PropTypes.func
}

export default HorseFinder



// WEBPACK FOOTER //
// ./src/components/Ad/HorseFinder.js